var map = {
	"./gift_10.webp": "1f7f",
	"./gift_100.webp": "c771",
	"./gift_25.webp": "28f1",
	"./gift_250.webp": "6006",
	"./gift_3.webp": "3289",
	"./gift_5.webp": "032d",
	"./gift_50.webp": "9b22",
	"./gift_500.webp": "de74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a5bd";